<template functional>
  <container-priority
    :item="{ id: props.item.id, priority: props.item.priority }"
  />
</template>

<script>
export default {
  name: "fltl-priority",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
